import React, { useState, useEffect, useCallback } from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import students2019 from '../assets/estudantes2019.json';
import students2020 from '../assets/estudantes2020.json';
import students2021 from '../assets/estudantes2021.json';
import students2022 from '../assets/estudantes2022.json';
import students2023 from '../assets/estudantes2023.json';
import students2024 from '../assets/estudantes2024.json';
import students2025 from '../assets/estudantes2025.json';
import students2026 from '../assets/estudantes2026.json';
import Footer from '../components/Footer/Footer';
import './MapView.css';
import DrawCampinas from './DrawCampinas/DrawCampinas';
import PlotStudentsLocation from '../components/PlotStudentsLocation/PlotStudentsLocation';
import { SchoolLocationIcon } from './SchoolLocationIcon';

const MapView = () => {
  const [currentLocation] = useState({ lat: -22.930556, lng: -47.058833 });
  const [zoom] = useState(11.5);
  const [countStudents, setCountStudents] = useState(0);
  const [year, setYear] = useState();
  const [students, setStudents] = useState([]);
  const [circleColor, setCircleColor] = useState('blue');
  const [courses, setCourses] = useState([]);
  const [courseSelected, setCourseSelected] = useState('all');
  const [studentCountByCourse, setStudentCountByCourse] = useState([]);

  console.log(students2022.estudantes.length);
  console.log(students2023.estudantes.length);
  console.log(students2024.estudantes.length);
  // console.log(students2025.estudantes.length);

  useEffect(() => {
    setYear(2026);
    setStudents(students2026.estudantes);
    setCountStudents(students2026.estudantes.length);
    setCircleColor('black');
  }, []);

  const handleCourses = useCallback(() => {
    const newCourses = [];
    const newStudentCountByCourse = [];
    students.map((student) => {
      if (newCourses.indexOf(student.curso) === -1) {
        newCourses.push(student.curso);
      }
      newStudentCountByCourse[student.curso] =
        (newStudentCountByCourse[student.curso] || 0) + 1;
      return null;
    });
    setCourses(newCourses);
    setStudentCountByCourse(newStudentCountByCourse);
  }, [students]);

  useEffect(() => {
    handleCourses();
  }, [students, handleCourses]);

  const handleChangeYear = (event) => {
    if (event.target.value === '2026') {
      console.log('Estudantes 2026');
      setStudents(students2026.estudantes);
      setCountStudents(students2026.estudantes.length);
      setCircleColor('black');
    }
    if (event.target.value === '2025') {
      console.log('Estudantes 2025');
      setStudents(students2025.estudantes);
      setCountStudents(students2025.estudantes.length);
      setCircleColor('red');
    }
    if (event.target.value === '2024') {
      console.log('Estudantes 2024');
      setStudents(students2024.estudantes);
      setCountStudents(students2024.estudantes.length);
      setCircleColor('black');
    }
    if (event.target.value === '2023') {
      console.log('Estudantes 2023');
      setStudents(students2023.estudantes);
      setCountStudents(students2023.estudantes.length);
      setCircleColor('red');
    }
    if (event.target.value === '2022') {
      console.log('Estudantes 2022');
      setStudents(students2022.estudantes);
      setCountStudents(students2022.estudantes.length);
      setCircleColor('purple');
    }
    if (event.target.value === '2021') {
      setStudents(students2021.estudantes);
      setCountStudents(students2021.estudantes.length);
      setCircleColor('blue');
    }
    if (event.target.value === '2020') {
      setStudents(students2020.estudantes);
      setCountStudents(students2020.estudantes.length);
      setCircleColor('red');
    }
    if (event.target.value === '2019') {
      setStudents(students2019.estudantes);
      setCountStudents(students2019.estudantes.length);
      setCircleColor('green');
    }
    if (event.target.value === '2018') {
      setStudents(students2020.estudantes);
      setCountStudents(students2020.estudantes.length);
      setCircleColor('#663300');
    }
    setYear(event.target.value);
  };

  const handleChangeCourse = (event) => {
    setCourseSelected(event.target.value);
  };

  return (
    <div className="map-page-container">
      {/* Cabeçalho Fixo IFSP - Fora da tag do Mapa */}
      <header className="header-ifsp">
        <div className="header-title-container">
          <h1>Distribuiçã Geográfica da Moradia dos Estudantes</h1>
          <h2>IFSP Campus Campinas - {year}</h2>
        </div>
      </header>

      {/* O Mapa ocupa o restante do espaço */}
      <Map center={currentLocation} zoom={zoom}>
        <TileLayer
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    maxZoom={19}
  />
        {/* <TileLayer
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        /> */}
        {/* <TileLayer
            url='https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          subdomains='abcd'
          maxZoom={19}
        /> */}
        <DrawCampinas />
        <PlotStudentsLocation
          students={students}
          color={circleColor}
          course={courseSelected}
        />

        <Marker position={[-22.947526, -47.14915752]} icon={SchoolLocationIcon}>
          <Popup>
            <div className='poup-text'>IFSP Campinas</div>
          </Popup>
        </Marker>

        <Marker position={[-22.84909, -47.23134]} icon={SchoolLocationIcon}>
          <Popup>
            <div className='poup-text'>IFSP Hortolândia</div>
          </Popup>
        </Marker>

        {/* A caixa de controles continuará no mapa por enquanto */}
        <div className='controles'>
          <label>Selecione o ano</label>
          <select onChange={handleChangeYear}>
            <option value='2026'>2026</option>
            <option value='2025'>2025</option>
            <option value='2024'>2024</option>
            <option value='2023'>2023</option>
            <option value='2022'>2022</option>
            <option value='2021'>2021</option>
            <option value='2020'>2020</option>
            <option value='2019'>2019</option>
            <option value='2018'>2018</option>
          </select>

          <label>Selecione o curso</label>
          <select onChange={handleChangeCourse}>
            <option value='all'>Todos</option>
            {courses.map((course) => {
              return (
                <option key={course} value={course}>
                  {course}
                </option>
              );
            })}
          </select>

          <div id='boxTotalEstudantes'>
            {courseSelected === 'all' ? (
              <p>Total de estudantes: {countStudents}</p>
            ) : (
              <p>Total de estudantes: {studentCountByCourse[courseSelected]}</p>
            )}
          </div>
        </div>
        <Footer />
      </Map>
    </div>
  );

};

export default MapView;
